import { Button, Stack, Typography } from "@mui/material";
import { useCallback } from "react";
import { useBulkUpdateWaitingRoomsMutation } from "src/api/services/tasksApi";
import { theme } from "src/assets/theme";
import { useSelection } from "src/context/ItemsSelectionProvider/useSelection";

interface Props {
  handleOpen: () => void;
}

const Actions = ({ handleOpen }: Props) => {
  const { selected, setSelected } = useSelection();
  const [updateRooms] = useBulkUpdateWaitingRoomsMutation();

  const handleUnassignRooms = useCallback(async () => {
    await updateRooms({
      ids: selected,
      status: "ADDED",
      assigned_at: null,
      assignee_id: null,
      assignee_type: null,
    });

    setSelected([]);
  }, [selected, setSelected, updateRooms]);

  const handleCancelRooms = useCallback(async () => {
    await updateRooms({
      ids: selected,
      status: "CANCELED",
      completed_at: new Date().toISOString(),
    });

    setSelected([]);
  }, [selected, setSelected, updateRooms]);

  return (
    <Stack
      width="100%"
      height={60}
      direction="row"
      bgcolor={theme.palette.teal[100]}
      justifyContent="space-between"
      alignItems="center"
      padding={"0 16px"}
    >
      <Typography>Selected: {selected.length}</Typography>
      <Stack direction={"row"} spacing={2}>
        <Button size="small" variant="secondary" onClick={handleOpen}>
          Reassign Room(s)
        </Button>
        <Button size="small" variant="alternate" onClick={handleUnassignRooms}>
          Unassign Room(s)
        </Button>
        <Button
          size="small"
          variant="outlined"
          onClick={handleCancelRooms}
          sx={{ backgroundColor: "red", color: "#ffffff" }}
        >
          Cancel Room(s)
        </Button>
      </Stack>
    </Stack>
  );
};

export default Actions;
